import { schema } from 'normalizr'

export const crush = new schema.Entity(
  'crushes',
  {},
  { idAttribute: 'senderId' }
)



// WEBPACK FOOTER //
// ./src/lib/schema.js